import React from "react";

import { DatePickerInputProps, DatePickerProps } from "types";

import DatePicker from ".";

const DatePickerMonth = ({
	name,
	value,
	placeholderText,
	className,
	wrapperClassName,
	onChange,
	onBlur,
	onFocus,
	minDate,
	maxDate,
	tabIndex,
	disabled,
	disabledSearch,
}: DatePickerInputProps & DatePickerProps) => {
	const handleDateChangeRaw = e => {
		e.preventDefault();
	};

	return (
		<DatePicker
			name={name}
			value={value}
			dateFormat="MMMM yyyy"
			onChange={onChange}
			onBlur={onBlur}
			onFocus={onFocus}
			placeholderText={placeholderText}
			className={className}
			wrapperClassName={wrapperClassName}
			showMonthYearPicker={true}
			showFullMonthYearPicker={true}
			minDate={minDate}
			maxDate={maxDate}
			tabIndex={tabIndex}
			disabled={disabled}
			onChangeRaw={disabledSearch ? handleDateChangeRaw : () => null}
		/>
	);
};

export default DatePickerMonth;
